import { Link } from "react-router-dom";

const stats = [
  { num: "1200+", label: "收录漫画" },
  { num: "80万+", label: "章节目录" },
  { num: "6大", label: "漫画分类" },
  { num: "24h", label: "持续更新" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden pt-24 md:min-h-[640px] md:pt-28">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20Chinese%20manga%20artwork%20collage%20with%20ink%20brush%20strokes%2C%20dynamic%20action%20lines%20and%20floating%20pages%2C%20warm%20vermillion%20red%20and%20golden%20amber%20palette%20on%20deep%20dark%20background%2C%20dramatic%20cinematic%20lighting%2C%20artistic%20and%20abstract&width=1920&height=1080&seq=hero-manhua-bg&orientation=landscape"
          alt="漫画网 - 漫画网漫画大全收录背景图"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>

      <div className="container-x relative z-10 flex w-full flex-col items-center py-14 text-center md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur md:text-sm">
          <i className="ri-flashlight-fill text-accent-400"></i>
          漫画网 · 漫画大全收录中心
        </span>
        <h1 className="mt-6 font-display text-3xl font-black leading-tight text-white md:text-5xl lg:text-6xl">
          漫画网收录漫画大全
          <br className="hidden md:block" />
          <span className="text-accent-400">按漫画分类快速定位</span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-lg">
          按漫画网漫画库、漫画网漫画分类、漫画网漫画目录快速定位，想看哪部直接进列表，收录范围一次全看清。
        </p>

        <div className="mt-8 flex w-full max-w-md flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/category/all"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-center text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto md:text-base"
          >
            进入漫画大全
          </Link>
          <Link
            to="/category/all?sort=views"
            className="w-full whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3.5 text-center text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto md:text-base"
          >
            查看排行榜
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-white/15 bg-white/10 px-4 py-5 backdrop-blur">
              <dt className="order-2 text-xs text-white/75">{s.label}</dt>
              <dd className="font-display text-2xl font-black text-accent-400 md:text-3xl">{s.num}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}